import { Link } from "react-router-dom";
import { useAuth } from "../auth/AuthContext";
import { Badge, Card, EmptyState, PageHeader, Tabs } from "../components/ui";

export default function SettingsPage() {
  const { user } = useAuth();

  return (
    <>
      <PageHeader title="Configurações" description="Preferências da conta e da organização." />

      <Tabs
        items={[
          {
            id: "account",
            label: "Conta",
            content: (
              <Card title="Sua conta">
                <dl className="grid gap-4 text-sm sm:grid-cols-3">
                  <div>
                    <dt className="font-mono text-[11px] uppercase text-ink-muted">Nome</dt>
                    <dd className="mt-1">{user?.name}</dd>
                  </div>
                  <div>
                    <dt className="font-mono text-[11px] uppercase text-ink-muted">E-mail</dt>
                    <dd className="mt-1">{user?.email}</dd>
                  </div>
                  <div>
                    <dt className="font-mono text-[11px] uppercase text-ink-muted">Perfil</dt>
                    <dd className="mt-1">
                      <Badge tone="info">{user?.role_label}</Badge>
                    </dd>
                  </div>
                </dl>
                <p className="mt-4 text-sm text-ink-muted">
                  Alterar nome, e-mail ou senha em{" "}
                  <Link to="/profile" className="text-brand hover:underline">
                    Perfil
                  </Link>
                  .
                </p>
              </Card>
            ),
          },
          {
            id: "organizations",
            label: "Organizações",
            content: (
              <Card title="Organizações do seu escopo">
                {user?.organizations?.length ? (
                  <ul className="space-y-2 text-sm">
                    {user.organizations.map((org) => (
                      <li key={org.id} className="flex items-center justify-between">
                        <span>{org.name}</span>
                        <Badge tone="neutral">{org.tier}</Badge>
                      </li>
                    ))}
                  </ul>
                ) : (
                  <EmptyState title="Nenhuma organização vinculada" />
                )}
              </Card>
            ),
          },
          {
            id: "secrets",
            label: "Variáveis e segredos",
            content: (
              <EmptyState
                title="Gestão de segredos em etapa futura"
                description="Os valores ficam criptografados no backend e nunca são devolvidos por inteiro ao navegador."
              />
            ),
          },
        ]}
      />
    </>
  );
}
